<div class="example-container">
  <mat-sidenav-container class="example-sidenav-container">
    <mat-sidenav
      opened
      #snav
      mode="side"
      class="left-sidebar"
      [ngClass]="{
        mobileSidenav: mobileQuery.matches || isShopifyUser,
        isOpened: isOpened,
      }"
      (keydown.escape)="toggleSidenavSize()"
      disableClose
    >
      <div
        class="sidenav-header"
        [class.is-sidenav-header-loading]="isLoading"
        style="justify-content: center"
      >
        <!-- [ngStyle]="{
          'justify-content': seoOnlyLinks ? 'center' : 'flex-start'
        }" -->
        <ng-container *ngIf="!isLoading">
          <ng-container *ngIf="seoOnlyLinks">
            <img
              src="../../assets/img/organic_icon_2.svg"
              style="width: 26px; height: 26px; border-radius: 6px"
              class="sidenav-main-image cursor_pointer"
              (click)="redirectToOrganic()"
              *ngIf="!whiteLabelTarget"
            />
            <img
              [src]="
                darkMode
                  ? whiteLabelTarget.logo.black
                  : whiteLabelTarget.logo.white
              "
              [style]="whiteLabelTarget.logo.style"
              class="sidenav-main-image cursor_pointer paid_logo"
              (click)="redirectToOrganic()"
              *ngIf="whiteLabelTarget"
            />
          </ng-container>
          <ng-container *ngIf="!seoOnlyLinks">
            <span
              class="sidenav-header-black_square"
              *ngIf="!mobileQuery.matches || isOpened"
            ></span>
            <img
              src="../../assets/img/login_logo_v2.svg"
              style="width: 22px; height: 22px; border-radius: 6px"
              class="sidenav-main-image"
              *ngIf="!whiteLabelTarget"
            />
            <img
              [src]="
                darkMode
                  ? whiteLabelTarget.logo.black
                  : whiteLabelTarget.logo.white
              "
              [style]="whiteLabelTarget.logo.style"
              class="sidenav-main-image cursor_pointer paid_logo"
              (click)="redirectToOrganic()"
              *ngIf="whiteLabelTarget"
            />
          </ng-container>
          <h3
            *ngIf="!whiteLabelTarget"
            (click)="redirectToOrganic()"
            [ngClass]="{ cursor_pointer: seoOnlyLinks }"
          >
            {{
              seoOnlyLinks ? ("sidenav_links.Organic" | translate) : "Behamics"
            }}
          </h3>
        </ng-container>
      </div>
      <div class="sidenav-header_hr"></div>
      <!-- <div class="sidenav-header" *ngIf="isSmall">
        <img
          class="sidenav-small-img"
          src="../../assets/img/favicon.png"
          alt=""
        />
      </div>
      <div *ngIf="isSmall" class="sidenav-header_hr"></div> -->

      <div class="master-admin-nav" style="display: flex; align-items: stretch">
        <mat-nav-list
          style="padding: 0; flex: 1; min-height: 300px; overflow: auto"
          class="sidenav_links_primary"
        >
          <ng-container
            *ngIf="
              !seoOnlyLinks && !adsOnlyLinks && !backlinkFreelancerOnlyLinks
            "
          >
            <ng-container *ngFor="let item of navigationLinksFiltered">
              <a
                mat-list-item
                routerLinkActive="active-route"
                [routerLink]="item.routerLink"
                (click)="navigationLinksCallback(item.title)"
                class="nav-item"
                [ngClass]="{ disabled: item?.disabled }"
              >
                <div class="nav-item-icon_container">
                  <img
                    [src]="item?.icon?.src"
                    [style]="item?.icon?.inlineStyle"
                  />
                </div>
                <span>
                  {{
                    this.getTranslatedText(item.title, "sidenav_links") | async
                  }}
                </span>
              </a>
              <ng-container *ngIf="item?.children.length > 0">
                <div
                  class="sub_navmenu"
                  [ngClass]="{
                    'sub-menu-active':
                      (item?.active && !mobileQuery.matches) ||
                      (item?.active && mobileQuery.matches && isOpened),
                  }"
                >
                  <mat-nav-list>
                    <a
                      *ngFor="let child of item.children"
                      mat-list-item
                      routerLinkActive="active-route"
                      [class.disabled]="
                        item?.title == 'Organic'
                          ? seoLinkLoadingChecker(item, child)
                          : item?.title == 'Ad Copilot'
                            ? (adsProjects?.length === 0 ||
                                selectedAdsProjectStatus.percentage < 100) &&
                              child?.disable_on_zero_projects
                            : false
                      "
                      [routerLink]="
                        item?.title == 'Organic'
                          ? !seoLinkLoadingChecker(item, child)
                            ? child.routerLink
                            : null
                          : item?.title == 'Ad Copilot'
                            ? (adsProjects?.length === 0 ||
                                selectedAdsProjectStatus.percentage < 100) &&
                              child?.disable_on_zero_projects
                              ? null
                              : child.routerLink
                            : child.routerLink
                      "
                    >
                      <span>
                        {{
                          this.getTranslatedText(child.title, "sidenav_links")
                            | async
                        }}
                      </span>
                    </a>
                  </mat-nav-list>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="seoOnlyLinks">
            <ng-container *ngFor="let item of navigationLinksFiltered">
              <a
                mat-list-item
                routerLinkActive="active-route"
                class="nav-item"
                [ngClass]="{
                  disabled: seoLinkLoadingChecker(item, null),
                }"
                [routerLink]="
                  !seoLinkLoadingChecker(item, null) ? item.routerLink : null
                "
              >
                <div style="display: flex; margin-right: 10px">
                  <ng-container *ngIf="item.materialIcon">
                    <mat-icon
                      class="list-icon material-icons-outlined"
                      style="font-size: 24px; height: 24px; width: 24px"
                    >
                      {{ item.materialIcon }}
                    </mat-icon>
                  </ng-container>
                  <ng-container *ngIf="item.svgIcon">
                    <ng-container *ngIf="item.svgIcon == 'link_svg_icon'">
                      <svg
                        viewBox="0 0 640 512"
                        style="
                          min-width: 18px;
                          width: 18px;
                          margin-left: 2px;
                          margin-right: 3px;
                          fill: var(--navmenu-icon-svg-color);
                        "
                      >
                        <path
                          d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                        />
                      </svg>
                    </ng-container>
                  </ng-container>
                </div>
                <span>
                  {{
                    this.getTranslatedText(item.title, "sidenav_links") | async
                  }}
                </span>
              </a>
              <div
                class="sidenav-header_hr sidenav-header_hr-my-20"
                *ngIf="item.title == 'Keywords'"
              ></div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="adsOnlyLinks">
            <ng-container *ngFor="let item of navigationLinksFiltered">
              <a
                mat-list-item
                routerLinkActive="active-route"
                class="nav-item"
                [ngClass]="{
                  disabled:
                    (adsProjects.length === 0 ||
                      selectedAdsProjectStatus.percentage < 100) &&
                    item.disable_on_zero_projects,
                }"
                [routerLink]="
                  (adsProjects.length === 0 ||
                    selectedAdsProjectStatus.percentage < 100) &&
                  item.disable_on_zero_projects
                    ? null
                    : item.routerLink
                "
              >
                <div style="display: flex; margin-right: 10px">
                  <ng-container *ngIf="item.materialIcon">
                    <mat-icon
                      class="list-icon material-icons-outlined"
                      style="font-size: 24px; height: 24px; width: 24px"
                    >
                      {{ item.materialIcon }}
                    </mat-icon>
                  </ng-container>
                  <ng-container *ngIf="item.svgIcon">
                    <ng-container *ngIf="item.svgIcon == 'link_svg_icon'">
                      <svg
                        viewBox="0 0 640 512"
                        style="
                          min-width: 18px;
                          width: 18px;
                          margin-left: 2px;
                          margin-right: 3px;
                          fill: var(--navmenu-icon-svg-color);
                        "
                      >
                        <path
                          d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                        />
                      </svg>
                    </ng-container>
                  </ng-container>
                </div>
                <span>
                  {{
                    this.getTranslatedText(item.title, "sidenav_links") | async
                  }}
                </span>
              </a>
              <div
                class="sidenav-header_hr sidenav-header_hr-my-20"
                *ngIf="item.title == 'Keywords'"
              ></div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="backlinkFreelancerOnlyLinks">
            <ng-container *ngFor="let item of navigationLinksFiltered">
              <a
                mat-list-item
                routerLinkActive="active-route"
                class="nav-item"
                [routerLink]="item.routerLink"
              >
                <div style="display: flex; margin-right: 10px">
                  <ng-container *ngIf="item.materialIcon">
                    <mat-icon
                      class="list-icon material-icons-outlined"
                      style="font-size: 24px; height: 24px; width: 24px"
                    >
                      {{ item.materialIcon }}
                    </mat-icon>
                  </ng-container>
                  <ng-container *ngIf="item.svgIcon">
                    <ng-container *ngIf="item.svgIcon == 'link_svg_icon'">
                      <svg
                        viewBox="0 0 640 512"
                        style="
                          min-width: 18px;
                          width: 18px;
                          margin-left: 2px;
                          margin-right: 3px;
                          fill: var(--navmenu-icon-svg-color);
                        "
                      >
                        <path
                          d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                        />
                      </svg>
                    </ng-container>
                  </ng-container>
                </div>
                <span>
                  {{
                    this.getTranslatedText(item.title, "sidenav_links") | async
                  }}
                </span>
              </a>
              <div
                class="sidenav-header_hr sidenav-header_hr-my-20"
                *ngIf="item.title == 'Keywords'"
              ></div>
            </ng-container>
          </ng-container>

          <div
            class="ga4-status-menu"
            *ngIf="gaStatusLoaded && checkRoleGuard('googleAnalyticsOption')"
          >
            <p>{{ "words.settings" | translate }}</p>
            <mat-nav-list>
              <a
                style="font-size: 12px !important"
                mat-list-item
                class="nav-item active-route"
                matTooltip="{{
                  'phrases.connect_to_google_analytics_tooltip' | translate
                }}"
                (click)="changeGa4Status()"
              >
                <div class="nav-item-icon_container">
                  <img src="./../../assets/img/ga4.svg" />
                </div>
                <span *ngIf="!gaStatus">{{
                  "phrases.connect_to_google_analytics" | translate
                }}</span>
                <span *ngIf="gaStatus">{{
                  "phrases.disconnect_google_analytics" | translate
                }}</span>
              </a>
            </mat-nav-list>
          </div>
        </mat-nav-list>
        <mat-nav-list
          class="sidenav_links_secondary"
          *ngIf="!hideSecondaryMenuLinks"
        >
          <div class="sidenav-header_hr"></div>
          <a
            *ngIf="checkRoleGuard('backendMetrics')"
            mat-list-item
            routerLinkActive="active-route"
            routerLink="/metrics/backend"
            (click)="closeParentTrigger()"
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">query_stats</mat-icon>
            </div>
            <span>{{ "sidenav_links.Backend Metrics" | translate }}</span>
          </a>
          <a
            *ngIf="checkRoleGuard('modelAutomationModels')"
            mat-list-item
            routerLinkActive="active-route"
            routerLink="/model-automation"
            (click)="closeParentTrigger()"
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">settings_suggest</mat-icon>
            </div>
            <span>{{ "sidenav_links.Model Automation" | translate }}</span>
          </a>
          <a
            mat-list-item
            class="parent-incentive"
            routerLinkActive="active-route"
            routerLink="/invoices"
            *ngIf="canShowInvoices"
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon material-icons-outlined">
                description
              </mat-icon>
            </div>
            <span>{{ "sidenav_links.Invoices" | translate }}</span>
          </a>
          <a
            mat-list-item
            routerLinkActive="active-route"
            routerLink="/seo/billing"
            *ngIf="
              (checkRoleGuard('seo_billing') && !whiteLabelTarget) ||
              (checkRoleGuard('seo_billing') &&
                whiteLabelTarget &&
                isMasterRole)
            "
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">credit_card</mat-icon>
            </div>
            <span>{{ "sidenav_links.Billing" | translate }}</span>
          </a>
          <a
            mat-list-item
            routerLinkActive="active-route"
            routerLink="/user-management"
            *ngIf="checkRoleGuard('masterUserManagement')"
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">person</mat-icon>
            </div>
            <span>{{ "sidenav_links.User Management" | translate }}</span>
          </a>

          <a
            mat-list-item
            routerLinkActive="active-route"
            routerLink="/user-permissions"
            *ngIf="checkRoleGuard('userPermissions')"
          >
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">person</mat-icon>
            </div>
            <span>
              {{
                this.getTranslatedText("Invite Users", "sidenav_links") | async
              }}
            </span>
          </a>
          <a
            mat-list-item
            (click)="sevenDaysFreeTrial()"
            routerLinkActive="active-route"
            *ngIf="is7DaysFreeTrial"
            class="seven-days-free-trial"
          >
            <div class="seven-days-free-trial-background"></div>
            <div class="nav-item-icon_container">
              <mat-icon class="list-icon">workspace_premium</mat-icon>
            </div>
            <span>
              <span *ngIf="daysLeft > 0">
                {{ daysLeft }}
                {{
                  (daysLeft == 1
                    ? "phrases.day_free_trial"
                    : "phrases.days_free_trial"
                  ) | translate: { count: daysLeft }
                }}
              </span>
              <span *ngIf="daysLeft <= 0">
                {{ "phrases.free_trial_expired" | translate }}
              </span>
            </span>
          </a>
        </mat-nav-list>

        <button
          mat-mini-fab
          style="color: #3a405b"
          id="side-trigger"
          (click)="toggleSidenavSize()"
          *ngIf="mobileQuery.matches || isShopifyUser"
        >
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <div
        class="custom_sidenav_background"
        (click)="toggleSidenavSize()"
      ></div>
      <div class="mat-sidenav-content_container">
        <mat-toolbar class="toolbar">
          <div
            class="date-controller-container"
            [ngClass]="{
              'controller-aligner':
                router.url == '/user-permissions' ||
                router.url == '/user-management' ||
                router.url == '/model-automation',
            }"
            [ngStyle]="{
              padding:
                seoOnly || backlinkFreelancerOnlyLinks ? '0px' : '0px 12px',
            }"
            *ngIf="
              router.url !== '/statistics-configurations' &&
              router.url !== '/predictions/returnrate' &&
              router.url !== '/atc-alert-system' &&
              router.url !== '/configuration' &&
              router.url !== '/nudges/preview' &&
              router.url !== '/invoices/list' &&
              router.url !== '/invoices' &&
              router.url !== '/invoices/configuration' &&
              router.url !== '/master-ai-experiments' &&
              router.url !== '/client-create-variant' &&
              router.url !== '/script-automation/configuration' &&
              router.url !== '/script-automation/debug' &&
              router.url !== '/management/bug-tracking' &&
              !router.url.includes('/recording/')
            "
          >
            <section class="configurator-theme-mode">
              <!-- Ads -->
              <ng-container *ngIf="router.url.includes('/ads/')">
                <div style="z-index: 0" class="search-console-button-container">
                  <button
                    class="btn_withoutIcon custom-button search-console-button"
                    mat-raised-button
                    type="button"
                    (click)="extensionButtonClicked()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      height="192"
                      viewBox="0 0 192 192"
                      width="192"
                    >
                      <path d="M0 0h192v192H0z" fill="none" />
                      <defs>
                        <path
                          d="M8 20v140c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12V20H8zm108 32H76c-4.42 0-8-3.58-8-8s3.58-8 8-8h40c4.42 0 8 3.58 8 8s-3.58 8-8 8z"
                          id="a"
                        />
                      </defs>
                      <clipPath id="b">
                        <use overflow="visible" xlink:href="#a" />
                      </clipPath>
                      <path
                        clip-path="url(#b)"
                        d="M8 20h176v152H8z"
                        fill="#eee"
                      />
                      <path
                        clip-path="url(#b)"
                        d="M116 36H76c-4.42 0-8 3.58-8 8s3.58 8 8 8h40c4.42 0 8-3.58 8-8s-3.58-8-8-8z"
                        fill="#fff"
                      />
                      <g clip-path="url(#b)">
                        <defs><circle cx="96" cy="160" id="c" r="76" /></defs>
                        <clipPath id="d">
                          <use overflow="visible" xlink:href="#c" />
                        </clipPath>
                        <path
                          clip-path="url(#d)"
                          d="M32.07 84v93.27h34.01L96 125.45h76V84zm0 0v93.27h34.01L96 125.45h76V84z"
                          fill="#DB4437"
                        />
                        <path
                          clip-path="url(#d)"
                          d="M20 236h72.34l33.58-33.58v-25.14l-59.84-.01L20 98.24zm0 0h72.34l33.58-33.58v-25.14l-59.84-.01L20 98.24z"
                          fill="#0F9D58"
                        />
                        <path
                          clip-path="url(#d)"
                          d="M96 125.45l29.92 51.82L92.35 236H172V125.45zm0 0l29.92 51.82L92.35 236H172V125.45z"
                          fill="#FFCD40"
                        />
                        <g clip-path="url(#d)">
                          <circle cx="96" cy="160" fill="#F1F1F1" r="34.55" />
                          <circle cx="96" cy="160" fill="#4285F4" r="27.64" />
                        </g>
                      </g>
                      <path
                        clip-path="url(#b)"
                        d="M8 20h176v76H8z"
                        fill="#212121"
                        fill-opacity=".05"
                      />
                      <path
                        d="M8 95h176v1H8z"
                        fill="#212121"
                        fill-opacity=".02"
                      />
                      <path d="M8 96h176v1H8z" fill="#fff" fill-opacity=".05" />
                      <path
                        d="M116 52H76c-4.25 0-7.72-3.32-7.97-7.5-.02.17-.03.33-.03.5 0 4.42 3.58 8 8 8h40c4.42 0 8-3.58 8-8 0-.17-.01-.33-.03-.5-.25 4.18-3.72 7.5-7.97 7.5zM8 20v1h176v-1H8z"
                        fill="#212121"
                        fill-opacity=".02"
                      />
                      <path
                        d="M76 36h40c4.25 0 7.72 3.32 7.97 7.5.01-.17.03-.33.03-.5 0-4.42-3.58-8-8-8H76c-4.42 0-8 3.58-8 8 0 .17.01.33.03.5.25-4.18 3.72-7.5 7.97-7.5zm96 135H20c-6.6 0-12-5.4-12-12v1c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12v-1c0 6.6-5.4 12-12 12z"
                        fill="#231F20"
                        fill-opacity=".1"
                      />
                      <radialGradient
                        cx="7.502"
                        cy="19.344"
                        gradientUnits="userSpaceOnUse"
                        id="e"
                        r="227.596"
                      >
                        <stop offset="0" stop-color="#fff" stop-opacity=".1" />
                        <stop offset="1" stop-color="#fff" stop-opacity="0" />
                      </radialGradient>
                      <path
                        d="M8 20v140c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12V20H8zm108 32H76c-4.42 0-8-3.58-8-8s3.58-8 8-8h40c4.42 0 8 3.58 8 8s-3.58 8-8 8z"
                        fill="url(#e)"
                      />
                    </svg>
                    <span> {{ "phrases.install_extension" | translate }} </span>
                  </button>
                </div>
              </ng-container>

              <!-- SEO -->
              <div
                *ngIf="
                  router.url.includes('/seo/') &&
                  !router.url.includes('/seo/billing') &&
                  !router.url.includes('/seo/integrations')
                "
                style="
                  z-index: 0;
                  display: flex;
                  align-items: center;
                  gap: 15px;
                "
                class="search-console-button-container"
              >
                <div
                  class="keywords-left-container"
                  [ngClass]="{
                    'keywords-left-container-mid':
                      keywordsUsedPercentage >= 50 &&
                      keywordsUsedPercentage < 98,
                    'keywords-left-container-green':
                      keywordsUsedPercentage < 50,
                  }"
                  *ngIf="showKeywordsLeft"
                  (click)="upgradeKeywordPlan()"
                >
                  <p>
                    {{ ("phrases.keywords_left" | translate) + ":" }}
                    <span>{{ formatComma(keywordsLeft) }} </span>
                    <span
                      style="
                        font-weight: 400;
                        font-size: 12px;
                        color: #000;
                        cursor: pointer;
                      "
                    >
                      | {{ "phrases.upgrade_plan" | translate }}</span
                    >
                  </p>
                </div>

                <button
                  *ngIf="!backlinkFreelancerOnlyLinks"
                  class="btn_withoutIcon custom-button search-console-button"
                  [ngClass]="{ isConnected: isGSCConnected }"
                  mat-raised-button
                  type="button"
                  (click)="redirectToIntegrations()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="100"
                    height="100"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#FFC107"
                      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                    ></path>
                    <path
                      fill="#FF3D00"
                      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                    ></path>
                    <path
                      fill="#4CAF50"
                      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                    ></path>
                    <path
                      fill="#1976D2"
                      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                    ></path>
                  </svg>
                  <span>
                    {{
                      isGSCConnected
                        ? ("words.connected" | translate)
                        : ("phrases.connect_search_console" | translate)
                    }}
                  </span>
                </button>
              </div>

              <ng-container *ngIf="showExplanationVideoBool">
                <button
                  class="page_explanations_button walkthrough_button"
                  (click)="displayVideo()"
                  *ngIf="showExplanationVideoBool"
                >
                  <mat-icon>play_arrow</mat-icon>
                  <span>
                    {{ "words.walkthrough" | translate }}
                  </span>
                </button>
                <button
                  class="page_explanations_button one-pager"
                  [class.seo-page-active]="router.url.includes('/seo/')"
                  (click)="openPdfClicked('onePager')"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 1H1v18h18V1H3zm14 2v14H3V3h14zm4 18H5v2h18V5h-2v16zM15 5H5v2h10V5zM5 9h10v2H5V9zm7 4H5v2h7v-2z"
                      fill="currentColor"
                    />
                  </svg>
                  <span> {{ "phrases.one_pager" | translate }} </span>
                </button>
                <button
                  class="page_explanations_button case-study"
                  [class.seo-page-active]="router.url.includes('/seo/')"
                  (click)="openPdfClicked('caseStudy')"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.2686 14.2686L15 16M12.0627 6.06274L11.9373 5.93726C11.5914 5.59135 11.4184 5.4184 11.2166 5.29472C11.0376 5.18506 10.8425 5.10425 10.6385 5.05526C10.4083 5 10.1637 5 9.67452 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V10.2C21 9.0799 21 8.51984 20.782 8.09202C20.5903 7.71569 20.2843 7.40973 19.908 7.21799C19.4802 7 18.9201 7 17.8 7H14.3255C13.8363 7 13.5917 7 13.3615 6.94474C13.1575 6.89575 12.9624 6.81494 12.7834 6.70528C12.5816 6.5816 12.4086 6.40865 12.0627 6.06274ZM14 12.5C14 13.8807 12.8807 15 11.5 15C10.1193 15 9 13.8807 9 12.5C9 11.1193 10.1193 10 11.5 10C12.8807 10 14 11.1193 14 12.5Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span> {{ "phrases.case_study" | translate }} </span>
                </button>
                <button
                  class="page_explanations_button demo_button"
                  [class.seo-page-active]="router.url.includes('/seo/')"
                  (click)="displayVideo(true)"
                >
                  <mat-icon>play_arrow</mat-icon>
                  <span> {{ "words.demo" | translate }} </span>
                </button>
              </ng-container>
            </section>

            <div
              class="dtholder range-sel sel1"
              *ngIf="
                router.url !== '/user-permissions' &&
                router.url !== '/user-management' &&
                router.url !== '/nudges/preview' &&
                router.url !== '/configuration' &&
                router.url !== '/model-automation' &&
                router.url !== '/invoices/list' &&
                router.url !== '/invoices' &&
                router.url !== '/invoices/configuration' &&
                router.url !== '/client-create-variant' &&
                router.url !== '/metrics/backend' &&
                router.url !== '/linkedin' &&
                !router.url.includes('/purchase-insights') &&
                !router.url.includes('/seo/') &&
                !backlinkFreelancerOnlyLinks &&
                !router.url.includes('/website-audit')
              "
            >
              <mat-form-field class="form-field first-picker">
                <p>{{ "words.range" | translate }}:</p>
                <mat-select
                  [(ngModel)]="selectedRangeValue"
                  name="range"
                  (selectionChange)="rangeChanged($event)"
                >
                  <mat-select-trigger>
                    {{ getSelectedRangeTranslateKey() | translate }}
                  </mat-select-trigger>
                  <mat-option
                    *ngFor="let range of ranges"
                    [value]="range.value"
                  >
                    {{ range.translateKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <span class="range-sel-border"></span>

            <button
              #dateBtn
              (click)="openDateRangeDialog(dateBtn)"
              class="dates-selector-button"
              *ngIf="
                router.url !== '/user-permissions' &&
                router.url !== '/user-management' &&
                router.url !== '/nudges/preview' &&
                router.url !== '/configuration' &&
                router.url !== '/model-automation' &&
                router.url !== '/invoices/list' &&
                router.url !== '/invoices' &&
                router.url !== '/invoices/configuration' &&
                router.url !== '/client-create-variant' &&
                router.url !== '/metrics/backend' &&
                router.url !== '/linkedin' &&
                !router.url.includes('/purchase-insights') &&
                !router.url.includes('/seo/') &&
                !backlinkFreelancerOnlyLinks &&
                !router.url.includes('/website-audit')
              "
            >
              <span>{{ "phrases.date_range" | translate }}:</span>
              {{ startDate | date: "MMM d, y" : undefined : currentLang }} -
              {{ endDate | date: "MMM d, y" : undefined : currentLang }}

              <svg
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
                fill="currentColor"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
                ></path>
              </svg>
            </button>
            <span
              class="range-sel-border"
              *ngIf="
                !router.url.includes('/purchase-insights/detailed') &&
                !router.url.includes('/merchandising/product-details')
              "
            ></span>
            <!-- Master Admin -->
            <div
              class="dtholder master-selector range-sel sel4"
              *ngIf="
                currentUserRole == 'master' &&
                router.url !== '/statistics-configurations' &&
                router.url !== '/predictions/returnrate' &&
                router.url !== '/invoices/list' &&
                router.url !== '/model-automation' &&
                router.url !== '/master-experiment-view' &&
                router.url !== '/master-new-experiment' &&
                router.url !== '/detailed/trace-error' &&
                router.url !== '/client-view-experiment' &&
                router.url !== '/client-create-variant' &&
                router.url !== '/metrics/backend' &&
                router.url !== '/client-results/overall' &&
                router.url !== '/notetaking'
              "
            >
              <mat-form-field
                class="client_selector"
                *ngIf="
                  !router.url.includes('/purchase-insights/detailed') &&
                  !router.url.includes('/merchandising/product-details')
                "
              >
                <p>{{ "words.client" | translate }}:</p>
                <mat-select
                  [(value)]="selectedStore"
                  (selectionChange)="onSelectionChange($event)"
                  id="targetSelector"
                  #clientSelect="matSelect"
                >
                  <mat-select-trigger>
                    <span class="target-selector">
                      {{ selectedStore }}
                    </span>
                  </mat-select-trigger>
                  <!-- Live clients -->

                  <mat-option
                    *ngFor="
                      let liveClient of liveClientList;
                      trackBy: trackByClient
                    "
                    [value]="liveClient.description"
                    class="target-selector-sidenav"
                    (mouseenter)="hoveredStoreId = liveClient._id"
                    (mouseleave)="hoveredStoreId = ''"
                    [ngClass]="{
                      'favorite-client-active': liveClient.isFavorite,
                    }"
                    [matTooltip]="
                      isTextTruncated(clientLabel) ? liveClient.description : ''
                    "
                    matTooltipPosition="above"
                  >
                    <span #clientLabel class="client-label">
                      {{ liveClient.description }}
                    </span>

                    <span
                      class="favorite-client"
                      *ngIf="
                        !nonBehamicsUser &&
                        (hoveredStoreId == liveClient._id ||
                          this.mobileQuery.matches ||
                          liveClient.isFavorite)
                      "
                      (click)="
                        $event.stopPropagation(); toggleFavorite(liveClient)
                      "
                    >
                      <mat-icon>star_rate</mat-icon>
                    </span>
                  </mat-option>

                  <!-- Workspaces -->
                  <div
                    *ngIf="!whiteLabelTarget"
                    (click)="toggleWorkspaces()"
                    class="secondary-selectors workspaces-button"
                    [class.showWorkspaces]="showWorkspaces"
                    [class.disabled]="workspacesClients?.length == 0"
                  >
                    <p class="non-live-header">
                      {{ "words.workspaces" | translate }} ({{
                        workspacesClients?.length
                      }})
                    </p>
                    <mat-icon
                      class="expand-icon"
                      *ngIf="!showWorkspaces"
                      fontIcon="arrow_drop_down"
                    ></mat-icon>
                    <mat-icon
                      class="expand-icon"
                      *ngIf="showWorkspaces"
                      fontIcon="arrow_drop_up"
                    ></mat-icon>
                  </div>
                  <ng-container *ngIf="showWorkspaces">
                    <mat-option
                      class="target-selector workspaces-selector"
                      *ngFor="
                        let workspace of workspacesClients;
                        trackBy: trackByClient
                      "
                      [value]="workspace?.description"
                    >
                      {{
                        workspace?.description?.replace("Workspace", "")?.trim()
                      }}
                    </mat-option>
                  </ng-container>

                  <!-- Non-Live Data header -->
                  <div
                    (click)="toggleNonLive()"
                    *ngIf="!whiteLabelTarget"
                    class="nonLive secondary-selectors"
                    [class.disabled]="notLiveClientList?.length == 0"
                  >
                    <p class="non-live-header">
                      {{ "words.non-live" | translate }} ({{
                        notLiveClientList?.length
                      }})
                    </p>
                    <mat-icon
                      class="expand-icon"
                      *ngIf="!showNonLive"
                      fontIcon="arrow_drop_down"
                    ></mat-icon>
                    <mat-icon
                      class="expand-icon"
                      *ngIf="showNonLive"
                      fontIcon="arrow_drop_up"
                    ></mat-icon>
                  </div>

                  <!-- Expandable non-live items -->
                  <ng-container *ngIf="showNonLive">
                    <mat-option
                      class="target-selector notlive-target"
                      *ngFor="
                        let notLiveClient of notLiveClientList;
                        trackBy: trackByClient
                      "
                      [value]="notLiveClient.description"
                    >
                      {{ notLiveClient.description }}
                    </mat-option>
                  </ng-container>

                  <div
                    class="sidenav-search-input"
                    *ngIf="clientList?.length > 7"
                  >
                    <input
                      placeholder="{{ 'phrases.search_client' | translate }}"
                      [(ngModel)]="clientSearchValue"
                      (keyup)="searchTargets()"
                      (keydown.space)="$event.stopPropagation()"
                    />
                  </div>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Other Combined Users -->
            <div
              class="dtholder master-selector range-sel sel4"
              *ngIf="
                currentUserRole == 'sub-master' &&
                router.url !== '/statistics-configurations' &&
                router.url !== '/predictions/returnrate' &&
                router.url !== '/atc-alert-system' &&
                router.url !== '/detailed/trace-error' &&
                router.url !== '/client-results/overall' &&
                !router.url.includes('/purchase-insights/detailed') &&
                clientList.length > 1 &&
                router.url !== '/notetaking' &&
                !router.url.includes('/merchandising/product-details')
              "
            >
              <mat-form-field class="client_selector">
                <mat-select
                  [(value)]="selectedStore"
                  (selectionChange)="targetChange()"
                  id="targetSelector"
                  placeholder="Store:"
                >
                  <mat-option
                    *ngFor="let client of clientList"
                    [value]="client.description"
                    class="target-selector"
                  >
                    {{
                      demoAccountForTarget
                        ? hideFirstPartOfString(client.description)
                        : client.description
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <button
            class="user-button"
            style="position: absolute; right: 20px; top: 21px"
            mat-icon-button
            [matMenuTriggerFor]="menu"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <mat-icon>account_circle</mat-icon>
            </div>
          </button>
        </mat-toolbar>

        <div class="sidenav-main_container">
          <div
            class="sidenav-tabs_container"
            [ngClass]="{
              'sidenav-tabs_container-no_tabs': !showNavWithTabs,
              has_own_tabs: hasOwnTabs,
              position_relative: invoiceStatus,
            }"
          >
            <div class="sidenav-tabs_container-title-container">
              <h3>
                {{ header | async }}

                <ng-container
                  *ngIf="
                    router.url.includes('/website-audit') &&
                    websiteAuditProjects?.length
                  "
                >
                  <button
                    class="custom-button"
                    mat-raised-button
                    type="button"
                    (click)="shareWebsiteAudit()"
                  >
                    <div class="button-with-svg">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2473_3050)">
                          <path
                            d="M9 15L15 9"
                            stroke="var(--text-main-color)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11 5.99982L11.463 5.46382C12.4008 4.52614 13.6727 3.99942 14.9989 3.99951C16.325 3.99961 17.5968 4.52651 18.5345 5.46432C19.4722 6.40212 19.9989 7.67401 19.9988 9.00017C19.9987 10.3263 19.4718 11.5981 18.534 12.5358L18 12.9998"
                            stroke="var(--text-main-color)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.0001 18L12.6031 18.534C11.6544 19.4722 10.3739 19.9984 9.03964 19.9984C7.70535 19.9984 6.42489 19.4722 5.47614 18.534C5.0085 18.0716 4.63724 17.521 4.38385 16.9141C4.13047 16.3073 4 15.6561 4 14.9985C4 14.3408 4.13047 13.6897 4.38385 13.0829C4.63724 12.476 5.0085 11.9254 5.47614 11.463L6.00014 11"
                            stroke="var(--text-main-color)"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2473_3050">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span> Share </span>
                    </div>
                  </button>
                  <button
                    class="custom-button download-button-website-audit"
                    mat-raised-button
                    type="button"
                    (click)="downloadWebsiteAudit()"
                    [disabled]="websiteAuditDownloading"
                    *ngIf="isBehamicsUser"
                  >
                    <div class="button-with-svg">
                      <svg
                        class="button_download_icon"
                        style="width: 13px; position: relative; top: -1px"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        *ngIf="!websiteAuditDownloading"
                      >
                        <title></title>
                        <g id="Complete">
                          <g id="download">
                            <g>
                              <path
                                d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                                fill="none"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                              ></path>
                              <g>
                                <polyline
                                  data-name="Right"
                                  fill="none"
                                  id="Right-2"
                                  points="7.9 12.3 12 16.3 16.1 12.3"
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                ></polyline>
                                <line
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  x1="12"
                                  x2="12"
                                  y1="2.7"
                                  y2="14.2"
                                ></line>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <mat-spinner
                        *ngIf="websiteAuditDownloading"
                      ></mat-spinner>
                      <span> Download </span>
                    </div>
                  </button>
                </ng-container>
              </h3>
              <div
                class="seo-automations_script_status"
                *ngIf="router.url == '/seo/automations'"
                style="margin-left: auto; margin-right: 20px"
                (click)="redirectToScripts()"
              ></div>
              <div
                class="sidenav-seo-tabs-container"
                style="display: flex; align-items: center; gap: 5px"
              >
                <!-- Ads -->
                <ng-container
                  *ngIf="
                    router.url.includes('/ads/') &&
                    !router.url.includes('/ads/projects')
                  "
                >
                  <div class="tab_option_picker">
                    <mat-form-field
                      class="bhm-option-container-1"
                      [ngStyle]="{
                        '--form-field-infix-width':
                          !adsProjectsFiltered ||
                          adsProjectsFiltered?.length === 0
                            ? '200px'
                            : '260px',
                        '--label-name':
                          '\'' + ('words.project' | translate) + ':\'',
                      }"
                    >
                      <mat-select
                        [(ngModel)]="selectedAdsProjectDomain"
                        (selectionChange)="adsProjectChanged()"
                        [disabled]="
                          !adsProjectsFiltered ||
                          adsProjectsFiltered?.length === 0
                        "
                      >
                        <mat-option
                          class="bhm-option-select-option-1 bhm-option-select-option-height-40"
                          *ngFor="let project of adsProjectsFiltered"
                          [value]="project.domain"
                        >
                          {{ project?.project }} - {{ project?.domain }}
                        </mat-option>
                        <div
                          class="sidenav-search-input"
                          *ngIf="
                            adsProjectsFiltered &&
                            adsProjectsFiltered?.length > 7
                          "
                        >
                          <input
                            placeholder="{{
                              'words.search_projects' | translate
                            }}"
                            (keyup)="searchAdsProjects($event)"
                          />
                        </div>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <!-- Website Audit -->
                <ng-container *ngIf="router.url.includes('/website-audit')">
                  <div class="tab_option_picker">
                    <mat-form-field
                      class="bhm-option-container-1"
                      [ngStyle]="{
                        '--form-field-infix-width': '240px',
                        '--label-name':
                          '\'' + ('words.audit' | translate) + ':\'',
                      }"
                    >
                      <mat-select
                        [(ngModel)]="selectedWebsiteAuditProjectId"
                        (selectionChange)="websiteAuditProjectChanged()"
                        [disabled]="
                          !websiteAuditProjects ||
                          websiteAuditProjects?.length === 0
                        "
                      >
                        <mat-option
                          class="bhm-option-select-option-1 bhm-option-select-option-height-40"
                          *ngFor="let audit of websiteAuditProjects"
                          [value]="audit.taskId"
                          [disabled]="audit?.status == 'Failed'"
                          [style.display]="
                            websiteAuditProjectsFiltered.includes(audit?.domain)
                              ? 'none'
                              : ''
                          "
                        >
                          {{ audit?.domain }}
                          <ng-container *ngIf="audit?.status == 'Failed'">
                            - {{ "words.failed" | translate }}
                          </ng-container>
                          <ng-container
                            *ngIf="audit?.progress && audit?.progress < 100"
                          >
                            - {{ audit?.progress }}%
                          </ng-container>
                        </mat-option>
                        <div
                          class="sidenav-search-input"
                          *ngIf="
                            websiteAuditProjects &&
                            websiteAuditProjects?.length > 7
                          "
                        >
                          <input
                            placeholder="{{
                              'phrases.search_audits' | translate
                            }}"
                            (keyup)="searchWebsiteAuditProjects($event)"
                          />
                        </div>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <div
                  class="dtpickerall"
                  style="display: flex; align-items: center; gap: 5px"
                  *ngIf="
                    router.url.includes('/seo/ai-analysis') &&
                    !router.url.includes('/seo/ai-analysis/issue')
                  "
                >
                  <div
                    class="custom_label_box"
                    *ngIf="!seoStillLoadingBlock && allKeywords?.total_keywords"
                  >
                    <p
                      routerLink="/seo/keywords"
                      style="cursor: pointer; text-transform: lowercase"
                    >
                      {{ formatComma(allKeywords?.total_keywords) }}
                      {{ "words.keywords" | translate }}
                    </p>
                  </div>
                  <div
                    class="custom_label_box"
                    *ngIf="
                      !seoStillLoadingBlock && allKeywords?.variables?.date
                    "
                  >
                    <p [matTooltip]="allKeywords?.variables?.date">
                      {{ "words.analysis_date" | translate }}:
                      {{
                        allKeywords?.variables?.date | date: "EEE, dd MMM yyyy"
                      }}
                    </p>
                  </div>

                  <mat-form-field
                    class="bhm-option-container-1"
                    [ngStyle]="{
                      '--form-field-infix-width': '220px',
                      '--label-name':
                        '\'' + ('words.competitor' | translate) + ':\'',
                    }"
                    *ngIf="
                      !seoStillLoadingBlock &&
                      this.seoSubscription == 'Premium' &&
                      keyWordData?.length > 0
                    "
                  >
                    <mat-select
                      [(ngModel)]="selectedKeyWordData"
                      (selectionChange)="
                        onSelectKeywordData(selectedKeyWordData)
                      "
                    >
                      <mat-option
                        class="bhm-option-select-option-1"
                        value="deselect_competitor"
                        [style.display]="
                          selectedKeyWordData == 'deselect_competitor'
                            ? 'none'
                            : ''
                        "
                      >
                        {{
                          selectedKeyWordData == "deselect_competitor"
                            ? ("phrases.select_competitor" | translate)
                            : ("phrases.deselect_competitor" | translate)
                        }}
                      </mat-option>
                      <mat-option
                        class="bhm-option-select-option-1"
                        *ngFor="let data of keyWordData"
                        [value]="data"
                      >
                        {{ data.domain }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  class="tab_option_picker"
                  *ngIf="
                    router.url.includes('/seo/') &&
                    !router.url.includes('/seo/onboarding') &&
                    !router.url.includes('/seo/billing') &&
                    !router.url.includes('/seo/projects') &&
                    !router.url.includes('/seo/ai-analysis/issue') &&
                    !backlinkFreelancerOnlyLinks
                  "
                >
                  <mat-form-field
                    class="bhm-option-container-1"
                    [ngStyle]="{
                      '--form-field-infix-width': '180px',
                      '--label-name':
                        '\'' + ('words.project' | translate) + ':\'',
                    }"
                  >
                    <mat-select
                      [(ngModel)]="selectedSeoProjectURL"
                      (selectionChange)="seoProjectChanged()"
                    >
                      <mat-option
                        class="bhm-option-select-option-1 bhm-option-select-option-height-40"
                        *ngFor="let project of seoProjectsFiltered"
                        [value]="project.url"
                      >
                        {{ project.domain ? project.domain : project.url }}
                      </mat-option>
                      <div
                        class="sidenav-search-input"
                        *ngIf="seoProjects && seoProjects?.length > 7"
                      >
                        <input
                          placeholder="{{
                            'words.search_projects' | translate
                          }}"
                          (keyup)="searchProjects($event)"
                        />
                      </div>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div
                  class="tab_option_picker slide_toogle_picker"
                  *ngIf="!showGonserOverallSwitcher && showOverallSwitcher"
                >
                  <p>{{ "phrases.overall_view" | translate }}</p>
                  <mat-slide-toggle
                    [checked]="overallSwitcher"
                    (change)="updateOverallSwitcher()"
                  >
                  </mat-slide-toggle>
                </div>
                <div
                  class="tab_option_picker slide_toogle_picker"
                  *ngIf="showGonserOverallSwitcher && !showOverallSwitcher"
                >
                  <p>{{ "phrases.overall_view" | translate }}</p>
                  <mat-slide-toggle
                    [checked]="gonserOverallSwitcher"
                    (change)="updateGonserOverallSwitcher()"
                  >
                  </mat-slide-toggle>
                </div>

                <mat-toolbar
                  class="toolbar compare-dates-main"
                  style="margin: 0 20px 0 0; height: unset !important"
                  *ngIf="showCompareDatesContainer"
                >
                  <div
                    class="date-controller-container"
                    style="
                      padding: 0px 5px !important;
                      position: static !important;
                      margin: -4px 0;
                      margin-right: 40px;
                    "
                    *ngIf="isCompareDatesActive"
                  >
                    <button
                      #dateBtn
                      (click)="openDateRangeDialog(dateBtn, true)"
                      class="dates-selector-button"
                    >
                      <span>{{ "phrases.compare_to" | translate }}:</span>
                      {{ compareStartDate | date }} -
                      {{ compareEndDate | date }}

                      <svg
                        viewBox="0 0 24 24"
                        width="24px"
                        height="24px"
                        fill="currentColor"
                        focusable="false"
                        aria-hidden="true"
                      >
                        <path
                          d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <p>{{ "phrases.compare_to" | translate }}</p>
                  <mat-slide-toggle
                    [(ngModel)]="isCompareDatesActive"
                    (change)="compareDates(false)"
                  >
                  </mat-slide-toggle>
                </mat-toolbar>
              </div>
            </div>

            <!-- Invoices -->
            <div
              *ngIf="router.url.includes('/invoices') && invoiceStatus"
              class="invoice-totals-container"
            >
              <div
                class="invoice-totals-pill"
                (click)="invoiceFilterStatusChanged('paid')"
                [ngClass]="{
                  'active-pill': invoiceFilterStatus === 'paid',
                }"
              >
                {{ "words.paid" | translate }}:
                <span
                  >{{
                    invoiceStatus.totalPaid || 0
                      | currencyFormatter: false : "EUR"
                  }}
                  | {{ invoiceStatus.totalPaidCount || 0 }}
                </span>
                <div
                  class="loading-data-overlay"
                  *ngIf="invoiceStatus?.loading"
                >
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              </div>
              <div
                class="invoice-totals-pill"
                (click)="invoiceFilterStatusChanged('unpaid')"
                [ngClass]="{
                  'active-pill': invoiceFilterStatus === 'unpaid',
                }"
              >
                {{ "words.unpaid" | translate }}:
                <span
                  >{{
                    invoiceStatus.totalUnpaid || 0
                      | currencyFormatter: false : "EUR"
                  }}
                  | {{ invoiceStatus.totalUnpaidCount || 0 }}
                </span>
                <div
                  class="loading-data-overlay"
                  *ngIf="invoiceStatus?.loading"
                >
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              </div>
              <div
                class="invoice-totals-pill"
                (click)="invoiceFilterStatusChanged('unsent')"
                [ngClass]="{
                  'active-pill': invoiceFilterStatus === 'unsent',
                }"
              >
                {{ "words.unsent" | translate }}:
                <span
                  >{{
                    invoiceStatus.totalUnsent || 0
                      | currencyFormatter: false : "EUR"
                  }}
                  | {{ invoiceStatus.totalUnsentCount || 0 }}
                </span>
                <div
                  class="loading-data-overlay"
                  *ngIf="invoiceStatus?.loading"
                >
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              </div>
            </div>
          </div>

          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<mat-menu x-position="before" y-position="below" #menu="matMenu">
  <div class="nav-menu-item user-info" (click)="$event.stopPropagation()">
    <div class="user-info-text">
      <p>
        {{
          "phrases.hi_userName" | translate: { name: userInfo?.name || "User" }
        }}
      </p>
    </div>
  </div>
  <div
    class="nav-menu-item"
    (click)="$event.stopPropagation()"
    *ngIf="showLanguageSelector"
  >
    <div
      class="custom_option_picker_with_absolute_label"
      (click)="$event.stopPropagation()"
    >
      <span class="custom_option_picker-label">
        {{ "words.language" | translate }}
      </span>
      <div class="custom_option_picker" (click)="$event.stopPropagation()">
        <mat-form-field
          class="create-invoice-modal-select-option"
          style="width: 100%"
          (click)="$event.stopPropagation()"
        >
          <mat-select
            [(ngModel)]="savedLang"
            (selectionChange)="changeLanguage($event.value)"
          >
            <mat-select-trigger>
              {{ getSelectedLanguageTranslateKey() | translate }}
            </mat-select-trigger>
            <mat-option
              *ngFor="let lang of languages"
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              [value]="lang.code"
            >
              {{ lang.label | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="nav-menu-item" (click)="$event.stopPropagation()">
    <div
      class="custom_option_picker_with_absolute_label"
      (click)="$event.stopPropagation()"
    >
      <span class="custom_option_picker-label">
        {{ "words.timezone" | translate }}
      </span>
      <div class="custom_option_picker" (click)="$event.stopPropagation()">
        <mat-form-field
          class="create-invoice-modal-select-option"
          style="width: 100%"
          (click)="$event.stopPropagation()"
        >
          <mat-select
            [(ngModel)]="selectedTimezone"
            (selectionChange)="timezoneChanged()"
            (click)="$event.stopPropagation()"
          >
            <mat-select-trigger>
              {{ selectedTimezone }}
            </mat-select-trigger>
            <mat-option
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              *ngFor="let timezone of timezoneList"
              [value]="timezone.name"
            >
              {{ timezone.name }}
              <ng-container *ngIf="timezone.local_timezone"
                >- {{ "words.local" | translate }}
              </ng-container>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="nav-menu-item" (click)="$event.stopPropagation()">
    <div
      class="custom_option_picker_with_absolute_label"
      (click)="$event.stopPropagation()"
    >
      <span class="custom_option_picker-label">
        {{ "words.appearance" | translate }}
      </span>
      <div class="custom_option_picker" (click)="$event.stopPropagation()">
        <mat-form-field
          class="create-invoice-modal-select-option"
          style="width: 100%"
          (click)="$event.stopPropagation()"
        >
          <mat-select
            [(ngModel)]="selectedTheme"
            (selectionChange)="themeChanged()"
            (click)="$event.stopPropagation()"
          >
            <mat-select-trigger>
              {{ getSelectedThemeTranslateKey() | translate }}
            </mat-select-trigger>
            <mat-option
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              value="light"
            >
              {{ "phrases.light_mode" | translate }}
            </mat-option>
            <mat-option
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              value="dark"
            >
              {{ "phrases.dark_mode" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div
    class="nav-menu-item"
    (click)="$event.stopPropagation()"
    *ngIf="
      isBehamicsUser &&
      isTargetNudgelite &&
      (router.url.includes('/master-preview') ||
        router.url.includes('dashboard'))
    "
  >
    <div
      class="custom_option_picker_with_absolute_label"
      (click)="$event.stopPropagation()"
    >
      <span class="custom_option_picker-label">
        {{ "phrases.nudge_lite" | translate }}
      </span>
      <div class="custom_option_picker" (click)="$event.stopPropagation()">
        <mat-form-field
          class="create-invoice-modal-select-option"
          style="width: 100%"
          (click)="$event.stopPropagation()"
        >
          <mat-select
            [(ngModel)]="nudgeLiteToggleTheme"
            (selectionChange)="switchNudgeLiteModeTheme()"
            (click)="$event.stopPropagation()"
          >
            <mat-option
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              value="on"
            >
              {{ "words.active" | translate }}
            </mat-option>
            <mat-option
              class="bhm-option-select-option-1 bhm-option-select-option-height-40"
              value="off"
            >
              {{ "words.deactive" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div
    class="nav-menu-item"
    (click)="$event.stopPropagation()"
    *ngIf="!isShopifyUser"
  >
    <button
      (click)="logout()"
      mat-menu-item
      style="
        padding: 0 !important;
        min-height: unset !important;
        height: unset !important;
        justify-content: flex-start !important;
      "
    >
      <mat-icon>exit_to_app</mat-icon>
      <span>{{ "words.logout" | translate }}</span>
    </button>
  </div>
</mat-menu>

<ng-container *ngIf="currentUser">
  <app-intercom-chat-nudge
    [currentUser]="currentUser"
  ></app-intercom-chat-nudge>
</ng-container>
